import { components, StylesConfig } from "react-select";
import React from "react";
import { useSharedTranslations } from "../../lib/i18n";
import { Icon } from "../icons/icon";
import { Tooltip } from "../tooltip/tooltip";
import style from "./react-select.module.scss"

export const NoOptionsMessage = (props: any) => {
    const t = useSharedTranslations();

    return (
        <components.NoOptionsMessage {...props}>
            <span>{t("noOptions")}</span>
        </components.NoOptionsMessage>
    );
};

export const OptionWithDescription = (props: any) => {
    return (
        <components.Option {...props}>
            <div className={style.selectOptionWithTooltip}>
                {props.data.label}
                {props.data.description && (
                    <Icon
                        data-tooltip-id="tooltip"
                        data-tooltip-content={props.data.description}
                        data-tooltip-place="top"
                        className={style.icon}
                        glyph="info"
                        size="m"
                    />
                )}
                <Tooltip id="tooltip"/>
            </div>
        </components.Option>
    );
}

export const ClearIndicator = () => {
    return null;
}

export const ClearIndicatorX = () => {
    return <Icon glyph="close"/>;
}


export const selectStyles: StylesConfig = {
    control: (styles, { isFocused }) => {
        return {
            ...styles,
            borderRadius: "12px",
            cursor: "pointer",
            color: "var(--hr-color-text-primary)",
            borderColor: isFocused ? "var(--hr-color-border-primary)" : "var(--hr-color-border-secondary)",
            backgroundColor: "var(--hr-color-surface-100)",
            boxShadow: "none",
            minHeight: "40px",

            ":hover": {
                borderColor: isFocused ? "var(--hr-color-border-primary)" : "var(--hr-color-border-secondary)",
            }
        }
    },
    input: (styles) => {
        return {
            ...styles,
            color: "var(--hr-color-text-primary)",
            backgroundColor: "transparent",
        }
    },
    multiValue: (styles) => {
        return {
            ...styles,
            color: "var(--hr-color-text-primary)",
            backgroundColor: "var(--hr-color-control-secondary)",
        }
    },
    multiValueLabel: (styles) => {
        return {
            ...styles,
            color: "var(--hr-color-text-primary)",
            backgroundColor: "var(--hr-color-control-secondary)",
        }
    },
    multiValueRemove: (styles) => {
        return {
            ...styles,
            color: "var(--hr-color-text-primary)",
            backgroundColor: "var(--hr-color-control-secondary)",
            opacity: "0.6",

            ":hover": {
                ...styles[":hover"],
                color: "var(--hr-color-text-primary)",
                backgroundColor: "var(--button-view-legal-fill-color-checked-hovered)",
            }
        }
    },
    indicatorSeparator: (styles) => ({ ...styles, display: "none" }),
    menu: (styles) => ({
        ...styles,
        backgroundColor: "var(--hr-color-surface-100)",
        zIndex: 10,
    }),
    option: (styles, { isSelected }) => {
        return {
            ...styles,
            cursor: "pointer",
            color: "var(--hr-color-text-primary)",
            backgroundColor: isSelected ? "var(--hr-color-control-secondary-hover)" : "var(--hr-color-surface-100)",

            ":hover": {
                backgroundColor: isSelected ? "var(--hr-color-control-secondary)" : "var(--hr-color-control-secondary-hover)"
            }
        };
    },
    placeholder: (styles) => ({ ...styles, zIndex: 1 }),
    singleValue: (styles, { isDisabled }) => ({
        ...styles,
        zIndex: 1,
        color: isDisabled ? "var(--hr-color-text-tertiary)" : "var(--hr-color-text-primary)",
    }),
    menuPortal: base => ({ ...base, zIndex: 9999 })
};
